/* eslint-disable import/prefer-default-export */
import rights from '../../../../components/rights';

export const getBlockedItemsByRights = projectId => {
  const blockItems = [];

  if (!rights.project.hasRight(projectId, 'delete_task')) {
    blockItems.push(...[
      'app_masschange_menu_remove',
    ]);
  }

  if (!rights.project.hasRight(projectId, 'static_fields')) {
    blockItems.push(...[
      'app_masschange_menu_choose_color',
    ]);
  }

  return blockItems;
};
